import { Modernizr } from '@lib/modernizr';
import { Component, HostBinding, EventEmitter, Output, ElementRef, OnInit } from '@angular/core';

@Component({
  selector: 'ie-not-supported-banner',
  styleUrls: ['./ie-not-supported-banner.component.scss'],
  templateUrl: './ie-not-supported-banner.component.html',
})
export class IeNotSupportedBannerComponent implements OnInit {
  @Output() public onBannerClose = new EventEmitter();
  @Output() public onBannerOpen = new EventEmitter();
  @HostBinding('class.hide') private bannerClosedEmitCalled: boolean = false;
  private el: HTMLElement;

  constructor(el: ElementRef) {
    this.el = el.nativeElement;
  }

  public ngOnInit() {
    this.bannerClosedEmitCalled = Modernizr.smil;
    const addHideClass: boolean = this.bannerClosedEmitCalled;
    const isHidden: boolean = this.el.classList.contains('hide');
    if (addHideClass && !isHidden) this.onBannerClose.emit();
    else if (!addHideClass && isHidden) this.onBannerOpen.emit();
  }

  public onClose() {
    this.bannerClosedEmitCalled = true;
    this.el.classList.add('hide');
    this.onBannerClose.emit();
  }
}
